import {
	LocationsQueryParams,
	LocationResponse,
	CreateLocationsRequest,
	LevelsLocationsResponse,
	SingleLocationResponse,
	GetLocationQueryParams,
	UpdateLocationRequest,
} from './types';
import { MutationRequest, NoContent } from '../types';
import { httpClient } from '../http';

export const getLevelLocations = async (
	levelId: string,
	queryParams: LocationsQueryParams
): Promise<LevelsLocationsResponse> => {
	const { data } = await httpClient.get<LevelsLocationsResponse>(`/locations/levels/${levelId}`, {
		params: queryParams,
	});

	return data;
};

export const getLocation = async (
	locationId: string,
	queryParams: GetLocationQueryParams
): Promise<SingleLocationResponse> => {
	const { data } = await httpClient.get<SingleLocationResponse>(`/locations/${locationId}`, {
		params: queryParams,
	});

	return data;
};

export const createLocations = async (
	siteId: string,
	{ request, formKey }: MutationRequest<CreateLocationsRequest>
) => {
	const { data } = await httpClient.post<Promise<LocationResponse[]>>(
		`/sites/${siteId}/locations`,
		request,
		{ headers: { formKey } }
	);

	return data;
};

export const deleteLocation = async (locationId: string): Promise<NoContent> => {
	const { data } = await httpClient.delete<Promise<NoContent>>(`/locations/${locationId}`);

	return data;
};

export const updateLocation = async (
	locationId: string,
	{ request, formKey }: MutationRequest<UpdateLocationRequest>
): Promise<LocationResponse> => {
	const { data } = await httpClient.patch<Promise<LocationResponse>>(
		`/locations/${locationId}`,
		request,
		{ headers: { formKey } }
	);

	return data;
};
